module.exports = __webpack_public_path__ + "img/150ne.059dc584.svg";